import $ from "jquery";
import Foundation from "./3rd/_zf.js";

import "./utils/global.js";
import "./utils/back-to-top.js";
import "./utils/script-loader.js";
import { initMenu } from "./utils/menu.js";

import { initSocialShare } from "./components/social-share.js";

// Styles
import "../styles/3rd/_index.scss";

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initMenu("nav.nav", ".main-nav");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "copy-link", "web-share"],
  });

  document.addEventListener(
    "click",
    function (e) {
      const fbBtn = e.target.closest(
        ".share-action-facebook, .share-intent-facebook"
      );
      if (!fbBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const url = window.location.href;

      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent(url),
        "_blank",
        "width=600,height=400"
      );
    },
    true
  );

  //
  // toggle menu footer
  //
  document.querySelectorAll("#footer-columns .footer-title").forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      this.classList.toggle("active");
    });
  });

  //
  // product attributes
  //
  const MIN_WIDTH = 250;
  const widgets = document.querySelectorAll(
    ".product-attributes .widget_layered_nav"
  );

  function adjustDropdown(widget) {
    const dropdown = widget.querySelector("ul");
    if (!dropdown) return;

    const toggleElem = widget.querySelector("span") || widget;
    const rect = toggleElem.getBoundingClientRect();
    const spaceRight = window.innerWidth - rect.right;

    if (spaceRight < MIN_WIDTH) {
      dropdown.classList.add("align-right");
    } else {
      dropdown.classList.remove("align-right");
    }
  }

  function closeAll() {
    widgets.forEach((el) => el.classList.remove("active"));
  }

  widgets.forEach((widget) => {
    widget.addEventListener("click", (e) => {
      if (e.target.closest("ul")) return;

      e.preventDefault();
      const isActive = widget.classList.contains("active");

      closeAll();

      if (!isActive) {
        widget.classList.add("active");
        adjustDropdown(widget);
      }
    });
  });

  window.addEventListener("resize", () => {
    const openWidget = document.querySelector(
      ".product-attributes .widget_layered_nav.active"
    );
    if (openWidget) adjustDropdown(openWidget);
  });
});

const observer = new MutationObserver(function (mutations, obs) {
  const emptyCartTitle = document.querySelector(
    ".wc-block-cart__empty-cart__title"
  );
  if (emptyCartTitle) {
    emptyCartTitle.textContent = "Giỏ hàng của bạn đang trống!";
    obs.disconnect(); // Dừng theo dõi sau khi đã thay xong
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("DOMContentLoaded", function () {
  const shareTitle = document.querySelector(".share-title");
  if (shareTitle) {
    // shareTitle.textContent = "Share";
  }
});

window.addEventListener("scroll", function () {
  const header = document.querySelector(".masthead");
  if (window.scrollY > 80) {
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".counter");

  const options = {
    threshold: 0.5,
  };

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const endValue = parseInt(el.dataset.count);
        const counter = new countUp.CountUp(el, endValue, {
          duration: 2,
          separator: ".",
        });
        counter.start();
        observer.unobserve(el);
      }
    });
  }, options);

  counters.forEach((counter) => observer.observe(counter));
});

document.addEventListener("DOMContentLoaded", function () {
  $(".parent-cat>a>i").click(function (e) {
    e.preventDefault();
    if (
      $(this).parent(".parent-cat>a").parent(".parent-cat").hasClass("active")
    ) {
      $(this)
        .parent(".parent-cat>a")
        .parent(".parent-cat")
        .removeClass("active");
    } else {
      $(this).parent(".parent-cat>a").parent(".parent-cat").addClass("active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("popup-hsnl");

  // Mở popup (gọi hàm này khi click nút)
  window.openHSNL = function () {
    popup.style.display = "flex";
  };

  // Đóng popup
  popup.querySelector(".hsnl-close").onclick = () => {
    popup.style.display = "none";
  };

  popup.onclick = e => {
    if (e.target === popup) popup.style.display = "none";
  };
});

document.addEventListener('wpcf7mailsent', function (event) {

  const popup = document.getElementById('popup-hsnl');
  if (!popup) return;

  // Hiện text cảm ơn
  const titleDownload = popup.querySelector('.title_dowload');
  if (titleDownload) {
    titleDownload.style.display = 'block';
  }

  // Lấy link hồ sơ năng lực
  const urlInput = popup.querySelector('input[name="url_profilr"]');
  if (!urlInput || !urlInput.value) return;

  const fileUrl = urlInput.value;

  // Tạo download tự động
  const a = document.createElement('a');
  a.href = fileUrl;
  a.setAttribute('download', '');
  a.setAttribute('target', '_blank');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

}, false);